import { createContext, ReactElement, useContext } from "react";
import GetMembros, { ResponseMembrosCheckin } from "../services/getMembros";


export const ServiceContextMensagens = createContext<ResponseMembrosCheckin>(null);


export const ProviderServicesMensagens = ({ children }: { children: ReactElement }) => {

  const services = GetMembros()

  return (
    <>
      <ServiceContextMensagens.Provider value={services}>
        {children}
      </ServiceContextMensagens.Provider>
    </>
  )
}

export const useServicesMensagens = () => {
  const context = useContext(ServiceContextMensagens)
  return context
}
